import clsx from "clsx";
import PropTypes from "prop-types";

import { useExternalLink } from "./use-external-link";

import "./external-link.scss";

export const ExternalLink = ({
  allowInSecureMode = false,
  children,
  className,
  href,
  ...anchorProps
}) => {
  const { blocked } = useExternalLink({ allowInSecureMode });

  if (blocked) {
    return (
      <span className={clsx("external-link-text", className)}>{children}</span>
    );
  }

  return (
    <a
      className={className}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      // Tells the secure mode guard this anchor is sanctioned.
      data-external-link=""
      {...anchorProps}
    >
      {children}
    </a>
  );
};

ExternalLink.displayName = "External Link";

ExternalLink.propTypes = {
  allowInSecureMode: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
};
